import React from "react";
import Checkbox from "material-ui/Checkbox";
import { Button, CircleIcons, muiLabelStyle } from "ui-components";
import { Editor, EditorState, ContentState } from "draft-js";

import {
  DraftComponentWrapper,
  EditorWrapper,
  TipEditorButtons
} from "./styled";

class SuggestedTipEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editorState: EditorState.createEmpty(),
      hasText: false,
      wasFocused: false
    };
  }

  /**
   * Enable setting the initial text value when editing
   */
  componentWillMount() {
    if (this.props.initialValue) {
      const newState = ContentState.createFromText(this.props.initialValue);
      const newEditState = EditorState.createWithContent(newState);
      this.setState({
        editorState: newEditState,
        hasText: true
      });
    }
  }

  /**
   * Enable autoFocus on draft component when it is on editingMode
   * Move the cursor to the end of text
   */
  componentDidMount() {
    if (this.props.isEditing) {
      this.editorRef.focus();
      const newEditorState = EditorState.moveFocusToEnd(this.state.editorState);
      this.setState({
        editorState: newEditorState
      });
    }
  }

  /**
   * Handle user input for the edited Suggested Tip
   * @param  {object} editorState New editor state
   */
  onChange = editorState => {
    this.setState({
      editorState
    });

    // Accept a onChange property function (to also run)
    if (typeof this.props.onChange === "function") {
      this.props.onChange(editorState);
    }

    // Handle empty text input
    if (editorState.getCurrentContent().getPlainText().trim()) {
      this.setState({ hasText: true });
    } else {
      this.setState({ hasText: false });
    }
  };

  /**
   * Handle the Enter key to save input
   */
  handleReturn = () => {
    this.onUpsertClick();
    return true;
  };

  /**
   * Clear the editor after performing an action
   */
  clearEditor = () => {
    // Reset the editor state
    this.setState({
      editorState: EditorState.createEmpty(),
      hasText: false,
      wasFocused: false
    });

    this.editorRef.blur();

    // Accept a clearEditor property function (to also run)
    if (typeof this.props.clearEditor === "function") {
      this.props.clearEditor();
    }
  };

  /**
   * Put the current focus on the editor
   */
  focusEditor = () => {
    this.editorRef.focus();
  };

  /**
   * Dispatch an upsert action and update the editor UI
   */
  onUpsertClick = () => {
    const { tipInfo } = this.props;

    const editorState = this.props.editorState || this.state.editorState;
    let newTipText = editorState.getCurrentContent().getPlainText().trim();

    // Only save the tip if something was entered
    if (newTipText) {
      // UI updates
      this.editorRef.blur();
      this.setState({
        editorState: EditorState.createEmpty(),
        hasText: false,
        wasFocused: false
      });

      // Dispatch an upsert action
      tipInfo.tipText = newTipText;
      this.props.upsertSuggestedTip(tipInfo);
    } else {
      this.clearEditor();
    }

    // Accept a toggleEditing property function (to also run)
    if (typeof this.props.toggleEditing === "function") {
      // Reset the editing state
      this.props.toggleEditing(false);
    }
  };

  /**
   * Dispatch a delete action and update the editor UI
   * @return {[type]} [description]
   */
  onDeleteClick = () => {
    const { tipInfo } = this.props;

    this.props.deleteSuggestedTip(tipInfo);
    this.props.toggleEditing(false);
  };

  render() {
    const { editorPlaceHolder, initialValue, toggleEditing } = this.props;
    const isEditMode = initialValue ? true : false;
    const { XCircle, PlusCircle } = CircleIcons;

    return (
      <DraftComponentWrapper>
        <Checkbox
          checked={true}
          disableTouchRipple
          labelStyle={muiLabelStyle}
          iconStyle={{ height: "18px", marginRight: "5px" }}
          style={{ width: "initial" }}
          checkedIcon={isEditMode ? <XCircle /> : <PlusCircle />}
          onClick={isEditMode ? () => this.onDeleteClick() : this.focusEditor}
        />
        <EditorWrapper>
          <Editor
            editorState={this.props.editorState || this.state.editorState}
            onChange={this.onChange}
            placeholder={editorPlaceHolder}
            ref={ref => {
              this.editorRef = ref;
            }}
            onFocus={() => this.setState({ wasFocused: true })}
            handleReturn={this.handleReturn}
          />
        </EditorWrapper>
        {/* Display the buttons once the current state is "edit" */}
        {!(this.state.hasText || this.state.wasFocused)
          ? null
          : <TipEditorButtons>
              <Button
                secondary
                onClick={isEditMode ? () => toggleEditing() : this.clearEditor}
                marginR={1}
                tiny
              >
                Cancel
              </Button>
              <Button primary tiny onClick={this.onUpsertClick}>
                {isEditMode ? "Save" : "Add"}
              </Button>
            </TipEditorButtons>}
      </DraftComponentWrapper>
    );
  }
}

export default SuggestedTipEditor;



// WEBPACK FOOTER //
// ./src/common/components/AppendixDialog/SuggestedTipEditor.jsx